const MENU_CURATION_TASK_TAGS = {
  IS_PROBLEMATIC: {
    value: 'IS_PROBLEMATIC',
    label: 'Is problematic',
    excludedBy: ['IS_NOT_PROBLEMATIC'],
  },
  IS_TRAINING: {
    value: 'IS_TRAINING',
    label: 'Is training',
    excludedBy: ['IS_NOT_TRAINING'],
    isOnlyForDuplicateTasks: true,
    disabled: true,
  },
  MANDATORY_TRAINING: {
    value: 'MANDATORY_TRAINING',
    label: 'Mandatory training',
    isOnlyForDuplicateTasks: true,
    disabled: true,
  },
  HOMEWORK_TRAINING: {
    value: 'HOMEWORK_TRAINING',
    label: 'Homework training',
    isOnlyForDuplicateTasks: true,
    disabled: true,
  },
  EXCLUDE_FROM_REPORTS: {
    value: 'EXCLUDE_FROM_REPORTS',
    label: 'Exclude from reports',
    disabled: true,
  },
  IS_TEST: {
    value: 'IS_TEST',
    label: 'Is test',
    excludedBy: ['IS_NOT_TEST'],
    disabled: true,
  },
  HAS_UNCAUGHT_AI_ERROR: {
    value: 'HAS_UNCAUGHT_AI_ERROR',
    label: 'Has uncaught AI error',
    disabled: true,
  },
  IS_OVERDUE: {
    value: 'IS_OVERDUE',
    label: 'Is Overdue',
    disabled: true,
  },
  IS_TOP_200: {
    value: 'IS_TOP_200',
    label: 'Is TOP 200',
    disabled: true,
  },
  CHAD: {
    value: 'CHAD',
    label: 'CHAD',
    disabled: true,
  },
  HAS_UNCAUGHT_MENU_CURATOR_ERROR: {
    value: 'HAS_UNCAUGHT_MENU_CURATOR_ERROR',
    label: 'Has uncaught Menu Curator error',
    disabled: true,
  },
  HAS_TIMEOUT_ERROR: {
    value: 'HAS_TIMEOUT_ERROR',
    label: 'Has timeout error',
    disabled: true,
  },
  HAS_METADATA_ERROR: {
    value: 'HAS_METADATA_ERROR',
    label: 'Has tier 2 dishes',
    disabled: true,
  },
}

export default MENU_CURATION_TASK_TAGS
